import moment from "moment";
import { NAV_GROUPS } from "../layout/navItems";

// Names for the access keys of the backend's utils/access.js; a role's name
// comes from the API with it. A key without one here is shown as its key, so
// one added there still shows.

// By a role's place in the API's list, where full comes first
const BADGES = [
  "text-purple-700 bg-purple-100 dark:text-purple-100 dark:bg-purple-700",
  "text-blue-700 bg-blue-100 dark:text-blue-100 dark:bg-blue-700",
  "text-green-700 bg-green-100 dark:text-green-100 dark:bg-green-700",
  "text-yellow-700 bg-yellow-100 dark:text-yellow-100 dark:bg-yellow-700",
  "text-pink-700 bg-pink-100 dark:text-pink-100 dark:bg-pink-700",
  "text-indigo-700 bg-indigo-100 dark:text-indigo-100 dark:bg-indigo-700",
];

const OTHER_BADGE = "text-gray-700 bg-gray-100 dark:text-gray-100 dark:bg-gray-700";

// Keys with no page of their own; the rest are named as in the sidebar
const ACTIONS = {
  "printer.create": "Принтер нэмэх",
  "printer.disable": "Принтер зогсоох",
  "service.assign": "Ажил тушаах",
};

// What a key gives beyond its page, for the role form
const HINTS = {
  plan: "Сарын зардлыг (цалин, түрээс) харж, засна.",
  service: "Киоскийн цаас, бэх хэзээ дуусахыг харж, очих өдрөө төлөвлөнө. Цаас, бэх нэмснээ бүртгэнэ.",
  "service.assign": "Киоскийг тодорхой өдөрт тушаана. Тушаасан өдрийг бусад нь өөрчилж чадахгүй.",
  admins: "Хэрэглэгч, эрхийг удирдана. Бусдад бүрэн эрх өгч чадна.",
  tenants: "Түрээслэгч нэмж, киоск онооно. Түрээслэгч зөвхөн өөрийн киоскийн тайланг харна.",
  ads: "Киоскийн дэлгэцэнд гарах зарыг оруулж, асааж, тоглолтын тайланг харна.",
  bundles: "Хэвлэлийн багцын төрөл, үнийг тохируулж, борлуулалтыг харна. Хэрэглэгчийн багцад хуудас, хоног нэмнэ.",
};

const SECTIONS = NAV_GROUPS.flatMap((group) => group.items).reduce(
  (labels, item) => ({ ...labels, [item.section]: item.label }),
  {}
);

export const roleName = (roles, role) => {
  const found = roles.find((item) => item.role === role);
  return found ? found.name : role;
};

export const roleBadge = (roles, role) => {
  const index = roles.findIndex((item) => item.role === role);
  return index < 0 ? OTHER_BADGE : BADGES[index % BADGES.length];
};

export const accessLabel = (key) => ACTIONS[key] || SECTIONS[key] || key;

export const accessHint = (key) => HINTS[key];

// The keys a role can be given, as the role form lists them: in the sidebar's
// groups, each section with the actions inside it (printer.disable under
// printer), then the keys the sidebar has no place for
export const accessGroups = (keys) => {
  const actionsOf = (section) => keys.filter((key) => key.startsWith(section + "."));
  const groups = NAV_GROUPS.map((group) => ({
    title: group.title || "Ерөнхий",
    items: group.items
      .filter((item) => keys.includes(item.section))
      .map((item) => ({ key: item.section, actions: actionsOf(item.section) })),
  })).filter((group) => group.items.length > 0);
  const listed = groups.flatMap((group) =>
    group.items.flatMap((item) => [item.key, ...item.actions])
  );
  const rest = keys.filter((key) => !listed.includes(key));
  return rest.length > 0
    ? [...groups, { title: "Нэмэлт үйлдэл", items: rest.map((key) => ({ key, actions: [] })) }]
    : groups;
};

// Stored 8 hours ahead, like the other dates of the API
export const dateText = (date) => (date ? moment.utc(date).format("YYYY-MM-DD") : "—");
